import { Injectable } from '@angular/core';
import * as moment from 'moment/moment.js';
import {
  ToastController,
  LoadingController,
  AlertController,
  ModalController,
  PopoverController,
  NavController,
  AlertButton,
} from '@ionic/angular';

import { TranslateService } from '@ngx-translate/core';
import { StorageService } from '../storage/storage.service';
import { DomSanitizer } from '@angular/platform-browser';
import { PopoverComponent } from 'src/app/components/popover/popover/popover.component';
import { Router } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import { DataReference } from 'src/app/interfaces/helpers';
@Injectable({
  providedIn: 'root',
})
export class FunctionsService {
  loading = null;
  data = {
    please_wait: '',
  };

  isLoading = false;
  constructor(
    private afs: AngularFirestore,
    private toastCtrl: ToastController,
    private popoverCtrl: PopoverController,
    private loadingCtrl: LoadingController,
    private sanitizer: DomSanitizer,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public translate: TranslateService,
    public router: Router,
    private navCtrl: NavController,
    public storeServ: StorageService
  ) { }

  redirect(url?: string) {
    url ? this.router.navigate([url]) : this.navCtrl.navigateRoot('/home/');
  }

  sanitizeImage(value: string) {
    // console.log(value);
    return this.sanitizer.bypassSecurityTrustUrl(value);
  }

  bypassSecurityTrustHtml(html) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  getMeta(metaName) {
    const metas = document.getElementsByTagName('meta');
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < metas.length; i++) {
      if (metas[i].getAttribute('name') === metaName) {
        return metas[i].getAttribute('content');
      }
    }
    return '';
  }

  filterData(data, queryWords) {
    let matchesQueryText = true;
    if (queryWords.length) {
      queryWords.forEach(queryWord => {
        if (data.name.toLowerCase().indexOf(queryWord) > -1) {
          matchesQueryText = false;
        }
      });
    } else {
      matchesQueryText = false;
    }

    return matchesQueryText;
  }

  async copy(text: string, toastColor?: string) {
    toastColor ? this.showToast('Texto copiado: ' + text, toastColor) : this.showToast('Texto copiado: ' + text);
    if (navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(text);
      } catch (err) { }
    }
  }

  getTime() {
    return moment(new Date().toISOString()).locale('es').format();
  }

  dateGetMoment(seconds: number) {
    console.log(seconds);
    console.log(
      moment(new Date(seconds * 1000).toISOString())
        .locale('es')
        .format()
    );
    return moment(new Date(seconds * 1000).toISOString())
      .locale('es')
      .format();
    // return new Date(seconds * 1000);
  }

  dateGetSeconds(seconds: number) {
    // console.log(seconds);
    return new Date(seconds * 1000);
    // return new Date(seconds * 1000);
  }

  dateGetFormat(seconds: number) {
    // console.log(seconds);
    return moment(new Date(seconds * 1000).toISOString())
      .locale('es')
      .format('LLL');
    // return new Date(seconds * 1000);
  }

  getDate(maxDate: boolean, years: number, days: number) {
    const today = new Date();

    if (maxDate) {
      const y = years * 365;
      const d = days + y;
      today.setSeconds(d * 86400);
    }
    const dd = today.getDate();
    const mm = today.getMonth() + 1; // January is 0!
    const yyyy = today.getFullYear();

    // tslint:disable-next-line:one-variable-per-declaration
    let sdd, smm, sToday;
    if (10 > dd) {
      sdd = '0' + dd;
    } else {
      sdd = dd;
    }
    if (10 > mm) {
      smm = '0' + mm;
    } else {
      smm = mm;
    }
    sToday = yyyy + '-' + smm + '-' + sdd;

    return sToday;
  }

  getTimeByDateTime(date: string, time: string): string {
    const myTime = time.split('T');
    let vt = '-';
    if (myTime[1].includes('+')) {
      vt = '+';
    }
    const argDate = myTime[1].split(vt);
    const myDate = date.split('T');
    const dateStart = myDate[0] + ' ' + argDate[0];
    return dateStart.substring(0, 19);
  }

  isFutureDate( seconds: number): boolean {const newDate = new Date( seconds * 1000);
    return newDate > new Date();
  }

  async showToast(msg: string, color?: string) {
    const toast = await this.toastCtrl.create({
      color: color ? color : 'primary',
      message: msg,
      duration: 3000,
      position: 'top',
      mode: 'ios',
    });
    toast.present();
  }

  async showSavedToast() {
    this.translate.get(['SAVED_CONFIRM']).subscribe(async values => {
      //  // console.log(values);
      const toast = await this.toastCtrl.create({
        color: 'success',
        message: values.SAVED_CONFIRM,
        duration: 3000,
        position: 'top',
        mode: 'ios',
      });
      toast.present();
    });
  }

  async presentPopover(ev: any, text: string) {
    console.log(ev)
    const popover = await this.popoverCtrl.create({
      component: PopoverComponent,
      componentProps: { text },
      cssClass: 'popover',
      event: ev,
      translucent: true,
    });
    await popover.present();
  }

  async showAlert(header: string, message: string, okText: string, autoCloseInTime?: number): Promise<any> {
    return new Promise(async resolve => {
      const alert = await this.alertCtrl.create({
        header,
        message,
        buttons: [
          {
            text: okText,
            handler: () => {
              resolve(true);
            },
          },
        ],
      });

      await alert.present();
      if (autoCloseInTime) {
        setTimeout(() => {
          alert.dismiss();
        }, autoCloseInTime);
      }
    });
  }

  showConfirm(header: string, message: string, cancelText: string, okText: string): Promise<boolean> {
    return new Promise(async resolve => {
      const alert = await this.alertCtrl.create({
        header,
        message,
        buttons: [
          {
            text: cancelText,
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => {
              resolve(false);
            },
          },
          {
            text: okText,
            handler: () => {
              resolve(true);
            },
          },
        ],
      });
      await alert.present();
    });
  }

  async showConfirmDelete(isPermanent: boolean = true): Promise<boolean> {
    const translations = await this.translate
      .get(['SOFTDELETE_CONFIRM', 'DELETE_CONFIRM', 'DELETE', 'CANCEL'])
      .toPromise();
    return new Promise(async resolve => {
      const alert = await this.alertCtrl.create({
        message: `${translations.SOFTDELETE_CONFIRM} ${isPermanent ? translations.DELETE_CONFIRM : ''}`,
        buttons: [
          {
            text: translations.CANCEL,
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => {
              resolve(false);
            },
          },
          {
            text: translations.DELETE,
            handler: () => {
              resolve(true);
            },
          },
        ],
      });
      await alert.present();
    });
  }

  async showConfirmGenerate(
    header: string,
    message: string,
    cancelText: string,
    okText: string[],
    cssClass?: string
  ): Promise<any> {
    return new Promise(async (resolve) => {
      const buttons: AlertButton[] = okText.map((text, index) => ({
        text, // Aquí ya no es necesario okText[position+1], simplemente usamos text
        handler: () => {
          resolve(text); // Asumiendo que quieres resolver con la posición + 1
        },
      }));
      
      if(cancelText.length > 0){
        // Agregar el botón de cancelar al inicio del arreglo de botones
        buttons.unshift({
          text: cancelText,
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            resolve('cancel');
          },
        });
      }
      
      const alert = await this.alertCtrl.create({
        header,
        message,
        buttons,
        cssClass,
      });
  
      await alert.present();
    });
  }

  async present(message?: string) {
    this.isLoading = true;
    let m = this.data.please_wait;
    if (message) {
      m = message;
    }
    return await this.loadingCtrl
      .create({
        message: m,
        duration: 10000,
        translucent: true,
        cssClass: 'custom-class siselse custom-loading',
      })
      .then(a => {
        a.present().then(() => {
          //  // console.log('presented');
          if (!this.isLoading) {
            a.dismiss().then(() => {
              // console.log('abort presenting')
            });
          }
        });
      });
  }

  async dismiss() {
    this.isLoading = false;
    try {
      return await this.loadingCtrl.dismiss().then(() => {
        // console.log('dismissed')
      });
    } catch (error) { }
  }

  getCode(code: number): string {
    let msg = '';
    switch (code) {
      case 0:
        msg = 'ACCESS_ATTEMPTS.CODE.0';
        break;
      case 1:
        msg = 'ACCESS_ATTEMPTS.CODE.1';
        break;
      case 2:
        msg = 'ACCESS_ATTEMPTS.CODE.2';
        break;
      case 3:
        msg = 'ACCESS_ATTEMPTS.CODE.3';
        break;
      case 4:
        msg = 'ACCESS_ATTEMPTS.CODE.4';
        break;
      case 5:
        msg = 'ACCESS_ATTEMPTS.CODE.5';
        break;
      case 6:
        msg = 'ACCESS_ATTEMPTS.CODE.2';
        break;
      case 7:
        msg = 'ACCESS_ATTEMPTS.CODE.7';
        break;
      case 8:
        msg = 'ACCESS_ATTEMPTS.CODE.2';
        break;
      case 9:
        msg = 'ACCESS_ATTEMPTS.CODE.2';
        break;
      case 10:
        msg = 'ACCESS_ATTEMPTS.CODE.2';
        break;
      case 11:
        msg = 'ACCESS_ATTEMPTS.CODE.11';
        break;
      case 12:
        msg = 'ACCESS_ATTEMPTS.CODE.12';
        break;
      case 100:
        msg = 'ACCESS_ATTEMPTS.CODE.DEFAULT';
        break;
      default:
        msg = 'ACCESS_ATTEMPTS.CODE.DEFAULT';
    }

    return msg;
  }

  getDateN(maxDate: boolean, days: number, startOrEndDay?: boolean) {
    const today = new Date();

    if (maxDate) {
      today.setSeconds(days * 86400);
    } else {
      // tslint:disable-next-line:no-unused-expression
      days > 0 ? today.setDate(today.getDate() - 1) : '';
    }

    const dd = today.getDate();
    const mm = today.getMonth() + 1; // January is 0!
    const yyyy = today.getFullYear();
    const hh = today.getHours();
    const mi = today.getMinutes();
    // tslint:disable-next-line:one-variable-per-declaration
    let sdd, smm, shh, smi, sToday;
    if (10 > dd) {
      sdd = '0' + dd;
    } else {
      sdd = dd;
    }
    if (10 > mm) {
      smm = '0' + mm;
    } else {
      smm = mm;
    }
    if (10 > hh) {
      shh = '0' + hh;
    } else {
      shh = hh;
    }
    if (10 > mi) {
      smi = '0' + mi;
    } else {
      smi = mi;
    }

    const tz = this.getTime().substr(19, 6);
    sToday = yyyy + '-' + smm + '-' + sdd + 'T' + shh + ':' + smi + tz;
    if (startOrEndDay !== undefined && startOrEndDay) {
      sToday = moment(new Date(sToday).toISOString()).locale('es').startOf('day').format();
    } else if (startOrEndDay !== undefined && !startOrEndDay) {
      sToday = moment(new Date(sToday).toISOString()).locale('es').endOf('day').format();
    } else {
      sToday = moment(new Date(sToday).toISOString()).locale('es').format();
    }

    return sToday;
  }

  parseDate(dateString: string): string {
    // Si la fecha es "0000-00-00 00:00:00", regresa '--/--/-- --:--'
    if (dateString === "0000-00-00 00:00:00") {
      return '--/--/-- --:--';
    }
  
    // Parsea la fecha
    const date = new Date(dateString);
  
    // Formatea la fecha y la hora
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
  
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  dateMoment(date: string): Date {
    return moment(new Date(date).toISOString()).locale('es').toDate();
  }

  dateByStartDay(date: Date): Date {
    return moment(new Date(date)).startOf('day').toDate();
  }

  dateByEndDay(date: Date): Date {
    return moment(new Date(date)).endOf('day').toDate();
  }

  getExcelFilename(type: string) {
    const today = new Date();
    const id = today.getTime().toString();
    return (
      'Reporte de ' +
      type +
      ' ' +
      today.getDay() +
      '/' +
      today.getMonth() +
      '/' +
      today.getFullYear() +
      '-' +
      id.substring(id.length - 3, id.length) +
      '.xlsx'
    );
  }

  checkAdmin(type, email) {
    let team = false;
    if (
      type === 'sipass' &&
      (email.includes('rmayorquin') ||
        email.includes('mvillanueva') ||
        email.includes('aosuna@siselse.com') ||
        email.includes('rosuna') ||
        email.includes('stephaniemdna@gmail.com') ||
        email.includes('michel.villanew@gmail.com'))
    ) {
      team = true;
    } else if (type === 'siselse') {
      if (email.includes('aosuna') || email.includes('mvillanueva@siselse.com')) {
        team = false;
      } else {
        if (email.includes('siselse')) {
          team = true;
        }
      }
    }
    return team;
  }

  getDataReference(collection: string, name: string, id: string): DataReference {
    return {
      name,
      ref: this.afs.collection(collection).doc(id).ref,
    };
  }

  generateDisplayData(array: string[], data: string[]): string[] {
    if (data.length > 0) {
      data.forEach(ds => {
        const dataTemp = ds.split('');
        let sTemp = '';
        if (dataTemp.length > 0) {
          dataTemp.forEach(d => {
            sTemp = sTemp.concat(d);
            array.push(sTemp.toLowerCase());
          });
        }
      });
    }
    return [...new Set(array)];
  }
}
